interface HighlightTextProps {
  text: string;
  keyword: string;
}

function escapeRegExp(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export default function HighlightText({ text, keyword }: HighlightTextProps) {
  const kw = keyword.trim();
  if (!kw) return <>{text}</>;

  const parts = text.split(new RegExp(`(${escapeRegExp(kw)})`, 'gi'));
  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === kw.toLowerCase() ? (
          <mark key={`hl-${i}`} className="rounded-sm bg-accent-200 px-0.5 text-accent-900">
            {part}
          </mark>
        ) : (
          <span key={`tx-${i}`}>{part}</span>
        ),
      )}
    </>
  );
}